var ModelFilter = (function () {
    function ModelFilter() {
    }
    //static $inject = ['topic'];
    ModelFilter.Factory = function () {
        return function (arr, targetField) {
            var results = [];
            var foundValues = [];
            angular.forEach(arr, function (lineItem) {
                if (foundValues.indexOf(lineItem[targetField]) < 0) {
                    foundValues.push(lineItem[targetField]);
                    results.push(lineItem);
                }
            });
            return results;
        };
    };
    return ModelFilter;
}());
ModelFilter = ModelFilter;
var ApproverFilter = (function () {
    function ApproverFilter() {
    }
    ApproverFilter.Factory = function () {
        return (function (componentArray, namesToExclude) {
            angular.forEach(componentArray, function (approver) {
                var i = namesToExclude.indexOf(approver.email);
                if (i > -1) {
                    componentArray.splice(i, 1);
                }
            });
            return componentArray;
        });
    };
    return ApproverFilter;
}());
ApproverFilter = ApproverFilter;
var StatusFilter = (function () {
    function StatusFilter() {
    }
    StatusFilter.Factory = function () {
        return function (stats) {
            var results = [];
            angular.forEach(stats, function (sub) {
                // Only add to the list if:
                if ((!sub.system || (sub.system && sub.systemOverride)) &&
                    sub.active !== false &&
                    (angular.isUndefined(sub.ignore) || (angular.isDefined(sub.ignore) && !sub.ignore))) {
                    results.push(sub);
                }
            });
            return results;
        };
    };
    return StatusFilter;
}());
StatusFilter = StatusFilter;
var IOTFilter = (function () {
    function IOTFilter() {
    }
    IOTFilter.Factory = function () {
        return function (countries, iots) {
            var results = [];
            angular.forEach(countries, function (cty) {
                //If the country's IOT is in the array AND the ic is set to Country
                if (angular.isDefined(iots) && iots.indexOf(cty.imt) > -1 && cty.ic === 'Country') {
                    results.push(cty);
                }
            });
            return results;
        };
    };
    return IOTFilter;
}());
IOTFilter = IOTFilter;
var RevFilter = (function () {
    function RevFilter() {
    }
    RevFilter.Factory = function () {
        return function (items) {
            return items.slice().reverse();
        };
    };
    return RevFilter;
}());
RevFilter = RevFilter;
var LinkyNotesFilter = (function () {
    function LinkyNotesFilter() {
    }
    LinkyNotesFilter.Factory = function ($sce) {
        /*
        var urlPattern = /(http|ftp|https|Notes):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi;
        return function (text: string, target: string) {
            return text.replace(urlPattern, '<a target="' + target + '" href="$&">$&</a>') ;
        */
        return function (text, target) {
            if (angular.isDefined(text)) {
                var foundLinks = text.match(/((http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])|(notes:\/\/[\w-.\/]+))/gi);
                //console.log('converting text: ' + text);
                var uniqueLinks = [];
                var foundDuplicate = void 0;
                if (angular.isDefined(foundLinks) && foundLinks !== null) {
                    for (var fl = 0; fl < foundLinks.length; fl++) {
                        foundDuplicate = false;
                        for (var ul = 0; ul < uniqueLinks.length; ul++) {
                            if (foundLinks[fl].indexOf(uniqueLinks[ul]) > -1) {
                                foundDuplicate = true;
                            }
                        }
                        ;
                        if (!foundDuplicate) {
                            uniqueLinks.push(foundLinks[fl]);
                        }
                    }
                }
                angular.forEach(uniqueLinks, function (link) {
                    //console.log('link is: ' + link + '.');
                    //console.log('<a target="' + target + '" href="' + link + '">' + link + '</a>');
                    //text = text.replace(link, '<a target="' + target + '" href="' + link + '">' + link + '</a>') ;
                    if (link.toLowerCase().indexOf('notes://') > -1) {
                        text = text.replace(new RegExp(link, 'g'), '<a target="_self" href="' + link + '" title="' + link + '">Lotus Link</a>');
                    }
                    else {
                        text = text.replace(new RegExp(link, 'g'), '<a target="' + target + '" href="' + link + '">' + link + '</a>');
                    }
                });
                text = text.split('<+g>').join('<span class="green_text"><b>');
                text = text.split('</+g>').join('</b></span>');
                text = text.split('<+r>').join('<span class="red_text"><b>');
                text = text.split('</+r>').join('</b></span>');
                text = text.split('<+b>').join('<span class="blue_text"><b>');
                text = text.split('</+b>').join('</b></span>');
                text = text.split('<+c>').join('<b>');
                text = text.split('</+c>').join('</b>');
                //return text;
                return $sce.trustAsHtml(text);
            }
            else {
                return '';
            }
        };
    };
    LinkyNotesFilter.replaceAll = function (target, search, replacement) {
        return target.replace(new RegExp(search, 'g'), replacement);
    };
    return LinkyNotesFilter;
}());
LinkyNotesFilter = LinkyNotesFilter;
angular
    .module('application')
    .filter('uniqueF', ModelFilter.Factory)
    .filter('multiIOT', IOTFilter.Factory)
    .filter('statusFilter', StatusFilter.Factory)
    .filter('reverseF', RevFilter.Factory)
    .filter('appFilter', ApproverFilter.Factory)
    .filter('linkyWithNotes', ['$sce', LinkyNotesFilter.Factory]);

//# sourceMappingURL=filters.js.map
